export default "__VITE_ASSET__fyoD_rg7__"